import React from 'react';
import { ListItemText as MuiListItemText } from '@material-ui/core';

const ListItemText = props => <MuiListItemText {...props} />;

export default ListItemText;
